export default "__VITE_ASSET__CpxhAX4I__"